<template>
  <!-- 班级帖子选择关联内容 -->
  <div class="about-content">
    <div class="details-top">
      <form action="/" class="logo-container">
        <van-search v-model="searchContent" right-icon="" shape="round" placeholder="搜索内容" @search="onCourseSearchEnter"
          :clearable="true" clear-trigger="always" @clear="clearSearchValue">
          <template #left-icon>
            <van-icon name="search" />
          </template>
        </van-search>
      </form>
      <div class="sec-flex">
        <div :class="['flex-txt', active === item.code ? 'cur' : '']" v-for="item in tabList" :key="item.code">
          <span>{{ item.name }}</span>
          <img v-show="item.code === active" src="@/assets/images/grade/img2.png" class="icon1" alt="" />
        </div>
      </div>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="con-list">
      <div class="con-item" v-for="(item, index) in searchList" :key="index" @click="handleClickItems(index)">
        <img src="@/assets/images/grade/select.png" v-if="item.isCheck" class="icon-item" alt="">
        <img src="@/assets/images/teacher-task/un-select.png" v-else class="icon-item" alt="">
        <div class="item-con">
          <img :src="item.coverMaterialUrl" class="con-cover" alt="">
          <div class="con-txt">{{ item.name }}</div>
        </div>
      </div>
    </van-list>
    <div class="confirm-btn" @click="handleConfirm">确定</div>
  </div>
</template>
<script>
import { changeCourse } from '@/api/grade'
import withRouteTracking from '@/utils/withRouteTracking'
import {handleTraceSearchLog} from '../../utils/trace'
const UserProfile = {
  data () {
    return {
      tabList: [{ code: '2', name: '课程' }],
      active: '1',
      searchContent: '',
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      load: false,
      searchList: [],
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    this.classId = this.$route.query.classId
  },
  methods: {
    onCourseSearchEnter (e) {
      // this.eachStorage()
      if (e) {
        this.searchContent = e
      }
      this.pageNum = 1
      this.finished = false
      this.searchList = []
      handleTraceSearchLog({
        'userId': this.userInfo.id,
        'searchContent': this.searchContent,
        'sessionId': localStorage.getItem('sessionId'),
        'type': 14,
        'entrance': 55,
      })
      this.onLoad()
      return false
    },
    onLoad () {
      if (this.load) {
        return
      }
      this.load = true
      changeCourse({
        'dataValue': this.searchContent,
        'displayType': '1',
        'pageNum': this.pageNum,
        'pageSize': this.pageSize
      }).then(res => {
        this.load = false
        if (res.data.list.length < this.pageSize) {
          this.finished = true
        }
        let changeCourseCon = JSON.parse(`${sessionStorage.getItem('changeCourseCon')}`)
        console.log(changeCourseCon)
        res.data.list.map(item => {
          item.isCheck = false
          if (changeCourseCon && changeCourseCon.length > 0) {
            changeCourseCon.map(changeItem => {
              if (item.id === changeItem.id) {
                item.isCheck = true
              }
            })
          }
        })
        this.searchList = this.searchList.concat(res.data.list)
        // 加载状态结束
        this.loading = false
        if (this.searchList.length <= 0) {
          this.isSearch = true
        } else {
          this.isSearch = false
        }
        this.pageNum++
      })
    },

    clearSearchValue (e) {
      this.onCourseSearchEnter()
    },
    handleClickItems (index) {
      this.searchList[index].isCheck = !this.searchList[index].isCheck
      let changeCourseCon = JSON.parse(sessionStorage.getItem('changeCourseCon') || '[]')
      let curItem = this.searchList[index]
      if (curItem.isCheck) {
        let found = changeCourseCon.some(item => item.id === curItem.id)
        if (!found) {
          changeCourseCon.push(curItem)
        }
      } else {
        changeCourseCon = changeCourseCon.filter(item => item.id !== curItem.id)
      }
      sessionStorage.setItem('changeCourseCon', JSON.stringify(changeCourseCon))
    },
    handleConfirm () {
      this.$router.go(-1)
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.about-content {
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(180deg, #EDF1F4 0%, #F2F7FA 100%);
  padding-top: 100px;
  box-sizing: border-box;

  .details-top {
    width: 100%;
    height: 90px;
    background-color: #fff2e8;
    background-image: url("../../assets/images/grade/student-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;

    .logo-container {
      /deep/ .van-search {
        background-color: transparent;

        .van-search__content {
          background: rgba(255, 255, 255, 0.5);
        }
      }
    }

    .sec-flex {
      display: flex;
      // padding: 0 45px;
      box-sizing: border-box;
      height: 42px;
      align-items: center;
      background-image: url("../../assets/images/zone/img28.png");
      background-repeat: no-repeat;
      background-size: contain;
      border-radius: 12px 12px 0 0;
      justify-content: space-between;

      .flex-txt {
        position: relative;
        height: 42px;
        line-height: 42px;
        font-size: 14px;
        color: #656E7F;
        font-weight: 500;
        flex: 1;
        text-align: center;

        &:nth-last-child(1) {
          margin-right: 0;
        }

        &.cur {
          font-weight: 600;
          color: #EB1700;
        }

        .icon1 {
          position: absolute;
          width: 23px;
          bottom: 4px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }

  .con-list {
    padding: 10px 16px;
    box-sizing: border-box;

    .con-item {
      background-color: #fff;
      padding: 10px 8px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      border-radius: 12px;
      margin-bottom: 10px;

      .icon-item {
        width: 14px;
        height: 14px;
        margin-right: 8px;
      }

      .item-con {
        display: flex;
        align-items: center;

        .con-cover {
          width: 110px;
          height: 60px;
          object-fit: cover;
          margin-right: 6px;
          min-width: 110px;
          border-radius: 8px;
        }

        .con-txt {
          font-size: 14px;
          color: #000000;
          font-weight: 500;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .confirm-btn {
    position: fixed;
    bottom: 24px;
    left: 14px;
    width: calc(100vw - 28px);
    height: 42px;
    border-radius: 100px;
    font-size: 16px;
    text-align: center;
    line-height: 42px;
    font-weight: 500;
    color: #fff;
    background-color: #EB1700;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/examineAboutContent.vue